import React from 'react';

const Footer = () =>{
    return(
        <footer id="footer">
            <div className="center">
                <p>
                    <span style={{color:"red"}}>&copy;</span> <a href="https://secrojas.com"  rel="noopener noreferrer" target='_blank' style={{color:"red"}}>secrojas</a>. Todos los derechos reservados.
                </p>
            </div>
        </footer>
    );
}

export default Footer;